import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-popup-info',
    templateUrl: './popup-info.component.html',
    styleUrls: ['./popup-info.component.scss'],
    standalone: false
})
export class PopupInfoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PopupInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}
